import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'wilson-activity-location-mismatch-indicator',
  imports: [TranslateModule],
  templateUrl: './activity-location-mismatch-indicator.component.html',
  styleUrls: ['./activity-location-mismatch-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityLocationMismatchIndicatorComponent {}
